import React from "react";

import { OrderType } from "context/AdminOrdersContext";

import UncompletedOrderCard from "./UncompletedOrderCard.tsx";
import CompletedOrderCard from "./CompletedOrderCard.tsx";

const CompletedOrdersTab: React.FC<{ orders: OrderType }> = ({ orders }) => {
  return (
    <div className="admin-order-panel completed-orders">
      {orders?.map((value, index) => (
        <CompletedOrderCard
          order={value}
          key={`completed-orders${index}`}
          index={index}
        />
      ))}
    </div>
  );
};

const WaitingOrdersTab: React.FC<{ orders: OrderType }> = ({
  orders,
  pageName,
}) => {
  return (
    <div className="admin-order-panel waiting-orders">
      {orders?.map((value, index) => (
        <UncompletedOrderCard
          order={value}
          key={`uncompleted-orders${index}`}
          index={index}
          pageName={pageName}
        />
      ))}
    </div>
  );
};

export { CompletedOrdersTab, WaitingOrdersTab };
